import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  SynonymDetailResponse,
  SynonymListQuery,
  SynonymListResponse,
  SynonymLogsQuery,
  SynonymLogsResponse,
  SynonymPreviewRequest,
  SynonymPreviewResponse,
  SynonymValidateRequest,
  SynonymValidateResponse,
  UserDictionaryResponse,
  searchDictionaryApi,
} from '../../../lib/api/searchDictionary';

export const searchDictionaryQuery = createQueryKeys('searchDictionary', {
  synonyms: (query: SynonymListQuery) => ({
    queryKey: [query],
    queryFn: (): Promise<SynonymListResponse> => searchDictionaryApi.getSynonyms(query),
  }),
  synonym: (ruleId: string) => ({
    queryKey: [ruleId],
    queryFn: (): Promise<SynonymDetailResponse> => searchDictionaryApi.getSynonym(ruleId),
  }),
  // 저장 전 검증·미리보기도 조회로 둔다 — 같은 입력이면 다시 묻지 않고, 입력이 바뀌면 새로 묻는다
  validation: (body: SynonymValidateRequest) => ({
    queryKey: [body],
    queryFn: (): Promise<SynonymValidateResponse> => searchDictionaryApi.validate(body),
  }),
  preview: (body: SynonymPreviewRequest) => ({
    queryKey: [body],
    queryFn: (): Promise<SynonymPreviewResponse> => searchDictionaryApi.preview(body),
  }),
  logs: (query: SynonymLogsQuery) => ({
    queryKey: [query],
    queryFn: (): Promise<SynonymLogsResponse> => searchDictionaryApi.getLogs(query),
  }),
  userDictionary: () => ({
    queryKey: ['current'],
    queryFn: (): Promise<UserDictionaryResponse> => searchDictionaryApi.getUserDictionary(),
  }),
});
